import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ORDERS_HISTORY_FEATURE_NAME } from '../../constants';
import { State } from '../orders.state';
import { orderHistoryAdapter } from './orders-history-list.adapter';

export const selectOrdersFeatureState = createFeatureSelector<State>(ORDERS_HISTORY_FEATURE_NAME);
const { selectAll } = orderHistoryAdapter.getSelectors();

export const selectOrderListState = createSelector(selectOrdersFeatureState, state => state.ordersHistoryList);

export const selectOrdersList = createSelector(selectOrderListState, selectAll);
export const selectOrdersLoading = createSelector(selectOrderListState, state => state.loading);
export const selectOrdersTotalCount = createSelector(selectOrderListState, state => state.totalCount);
